export default __webpack_public_path__ + "static/media/laka.dfa451c9.jpeg";